exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".popover-full-size-a7157 .ant-popover-inner .ant-popover-inner-content{padding:0}", ""]);

// Exports
exports.locals = {
	"full-size": "popover-full-size-a7157",
	"fullSize": "popover-full-size-a7157"
};